import classnames from 'classnames';
import CheckmarkCircle from '@icons/checkmark-circle-filled.svg';
import DoDisturbOnIcon from '@mui/icons-material/DoDisturbOn';
import styles from './ProductFeatureList.module.css';
import { Features } from '@shared/types/cancellation';
import classNames from 'classnames';

const {
  FeatureList: FeatureListClass,
  FeatureText,
  DisabledText,
  FeatureColumn,
  Spacer,
  CheckmarkContainer,
  FirstCheckmark,
  SecondCheckmark,
  DndStyle,
  FeatureListItemContainer,
  DarkGrayBackground,
} = styles;

interface ProductFeatureListProps {
  features: Features[];
  isBusiness: boolean;
}

export const ProductFeatureList: React.FC<ProductFeatureListProps> = ({
  features,
  isBusiness,
}) => {
  // Split features into two columns: first 7 in column 1, rest in column 2
  const firstColumnFeatures = features.slice(0, 7);
  const secondColumnFeatures = features.slice(7);

  return (
    <div
      className={classNames(
        FeatureListClass,
        {
          [DarkGrayBackground]: isBusiness,
        },
        FeatureListClass
      )}
    >
      <div className={FeatureColumn}>
        {firstColumnFeatures.map((feature: Features, index: number) => {
          const showDoubleCheckmark = feature.name.includes('x 2');

          return (
            <div
              key={`${feature.name}-${index}`}
              className={FeatureListItemContainer}
            >
              <span className={FirstCheckmark}>
                {feature.enabled ? (
                  <div className={CheckmarkContainer}>
                    <CheckmarkCircle className={FirstCheckmark} />
                    {showDoubleCheckmark && (
                      <CheckmarkCircle
                        className={classnames(FirstCheckmark, SecondCheckmark)}
                      />
                    )}
                  </div>
                ) : (
                  <DoDisturbOnIcon className={DndStyle} />
                )}
              </span>
              <span className={feature.enabled ? FeatureText : DisabledText}>
                {showDoubleCheckmark
                  ? feature.name.replace('x 2', '')
                  : feature.name}
              </span>
            </div>
          );
        })}
      </div>

      <div className={FeatureColumn}>
        {secondColumnFeatures.map((feature: Features, index: number) => {
          const showDoubleCheckmark = feature.name.includes('x 2');
          const showSpacer = index === 1;

          return (
            <div key={`${feature.name}-${index}`}>
              <div className={FeatureListItemContainer}>
                <span className={FirstCheckmark}>
                  {feature.enabled ? (
                    <div className={CheckmarkContainer}>
                      <CheckmarkCircle className={FirstCheckmark} />
                      {showDoubleCheckmark && (
                        <CheckmarkCircle
                          className={classnames(
                            FirstCheckmark,
                            SecondCheckmark
                          )}
                        />
                      )}
                    </div>
                  ) : (
                    <DoDisturbOnIcon className={DndStyle} />
                  )}
                </span>
                <span className={feature.enabled ? FeatureText : DisabledText}>
                  {showDoubleCheckmark
                    ? feature.name.replace('x 2', '')
                    : feature.name}
                </span>
              </div>
              {showSpacer && <div className={Spacer}></div>}
            </div>
          );
        })}
      </div>
    </div>
  );
};
